module.exports = __webpack_public_path__ + "assets/media/alexa-2.7cc5e83a.png";